export default "https://cdn-static-staging.gokick.com/assets/de9826e8866da471b448810e2f95d57cb57ac3c9/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";